






























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Form as MtdForm } from '@ss/mtd-vue';
import { State } from 'vuex-class';
import * as api from '@/api';
import * as validators from '@/utils/validator';
interface Form {
    name: string;
    rgId: number | string;
    template: string;
    templateType: string;
    sendXmNotify: boolean;
}
/**
 * 添加三级目录
 *
 * @author xiaokunyu
 * @date 01/11/2010
 */
@Component
export default class AddItemDialog extends Vue {
    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;

    @State(state => state.cti.env)
    env: string;

    @Prop({ default: false })
    visible: Boolean;
    @Prop({ default: 0 })
    parentId: number;
    @Prop({ default: 0 })
    itemId: number;
    @Prop({ default: false })
    isEdit: Boolean;

    show: Boolean = false;
    rgList: CommonTypes.RgItem[] = [];
    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    rgURL: string = '';
    templateTypeLabel = {
        CUSTOM: '自定义模板',
        NORMAL: '普通模板'
    };

    templateList: any = [];
    formCustom: Form = {
        name: '',
        rgId: '',
        template: '',
        templateType: '',
        sendXmNotify: false
    };
    originXmNotify: boolean = false;
    ruleCustom = {
        name: [{ validator: validators.validateName100, trigger: 'blur' }],
        rgId: [{ validator: validators.validateRg, trigger: 'change' }]
    };
    mounted() {
        this.getRgList('');
        const ONLINE_ENV: string = 'cti.sankuai.com';
        this.rgURL = window.location.host.indexOf(ONLINE_ENV) > -1 ? 'https://cti.sankuai.com/rg' : 'http://cti.cloud.test.sankuai.com/rg';
    }
    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        val && (this.$refs.formCustom as MtdForm).resetFields();
        if (val && this.isEdit && this.itemId) {
            this.getItemDetail();
        }
    }
    @Watch('formCustom.rgId')
    onRgIdChange(val) {
        this.templateList = [];
        if (val) {
            this.searchTemplate();
        }
    }
    rgChange() {
        this.formCustom.template = '';
    }
    close() {
        this.$emit('update:visible', false);
    }
    remoteMethod(query) {
        this.getRgList(query);
    }
    async getItemDetail() {
        try {
            const res = await api.ctiApi.getItemInfo(this.itemId);
            const { data } = res;
            this.formCustom.name = data.itemName;
            this.formCustom.rgId = data.rgId;
            this.formCustom.template = data.templateId;
            this.formCustom.templateType = data.templateType;
            this.formCustom.sendXmNotify = data.sendXmNotify || false;
            this.originXmNotify = this.formCustom.sendXmNotify;
            const ifRg = this.rgList.find(item => {
                return item.id === data.rgId;
            });
            if (!ifRg) {
                // FIXME: 这里有类型报错，因为 name, id 两个属性不满足 rgList 的类型声明: CommonTypes.RgItem
                this.rgList.push({
                    name: data.rgName,
                    id: data.rgId
                } as any);
            }
        } catch (e) {
            console.log(e);
        }
    }
    async getRgList(query) {
        this.searchLoading = true;
        try {
            const res = await api.ctiApi.getAllSpaceRg({ name: query, spaceId: 1 });
            this.rgList = res.data.items.map(item => {
                return {
                    name: item.name,
                    id: item.id
                };
            });
        } catch (e) {
            this.rgList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async searchTemplate() {
        this.searchLoading = true;
        try {
            const { rgId } = this.formCustom;
            const res = await api.rgApi.getRgTemplateList({
                rgId: rgId as number,
                sn: 100
            });
            this.templateList = res.data.items;
        } catch (e) {
            this.templateList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async submit() {
        if (this.btnLoading) {
            return;
        }
        (this.$refs.formCustom as MtdForm)
            .validate(async valid => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        const params = {
                            name: this.formCustom.name,
                            rgId: this.formCustom.rgId as number,
                            parentId: this.parentId,
                            templateId: (this.formCustom.template || 0) as number,
                            templateType: this.formCustom.templateType || '',
                            sendXmNotify: this.formCustom.sendXmNotify
                        };
                        if (this.isEdit) {
                            await api.ctiApi.editItem(this.itemId, params);
                        } else {
                            const paramsObj = Object.assign({}, params, {
                                state: 1
                            });
                            await api.ctiApi.addItem(paramsObj);
                        }
                        const successMessage = this.isEdit ? '编辑三级目录成功' : '添加三级目录成功';
                        // if (this.formCustom.sendXmNotify) {
                        //     successMessage += '及绑定大象微客服成功';
                        // }
                        this.$mtd.message({
                            message: successMessage,
                            type: 'success'
                        });
                        this.$emit('success');
                        this.close();
                    } catch (e) {
                        console.log(e);
                    }
                    this.btnLoading = false;
                } else {
                    console.error('Fail!');
                }
            })
            .catch(e => e);
    }
    get createTip() {
        let tipContent = '可以以产品功能或是用户常见问题命名三级';
        if ((this.env === 'prod' && this.parentId === 172) || (this.env === 'test' && this.parentId === 907)) {
            tipContent = '该目录下不创建其他目录，请到对应的一级目录下创建二、三级目录';
        }
        return tipContent;
    }
    handleTemplate(e) {
        let type = '';
        this.templateList.forEach(item => {
            if (item.id === e) {
                type = item.type;
            }
        });
        this.formCustom.templateType = type;
    }
}
